import axios from "axios";

// 初回 + 最大2回 = 計3回試行する
const MAX_RETRIES = 2;
// リトライ間隔の基準（ms）。ハブアドレスではサーバ側クエリがタイムアウトしても
// DBのバッファキャッシュが温まるため、間隔は短めにして温まったキャッシュが
// 押し出される前に再試行する。
const RETRY_BASE_DELAY_MS = 500;

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

// リトライ対象かどうかを判定する。
// - 5xx（statement_timeout由来の500 や 502/503/504 など）: サーバ側の一時的失敗 → リトライ
// - レスポンスなし（ネットワーク断 / クライアントタイムアウト）: → リトライ
// - 4xx（400 不正アドレス, 403 など）: リトライしても直らない → 対象外
function isRetriableError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === undefined) return true;
    return status >= 500;
  }
  return false;
}

export async function getHistoryByAddress(
  address: string,
  limit?: number,
  next?: string
): Promise<any> {
  const url = `${
    process.env.REACT_APP_HISTORY_API_URL
  }/${address.toLowerCase()}`;
  const params: { limit?: number; next?: string } = {};
  if (limit) params.limit = limit;
  if (next) params.next = next;

  let lastError: unknown;
  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const response = await axios.get(url, {
        headers: {
          "x-api-key": process.env.REACT_APP_HISTORY_API_KEY || "unknown",
        },
        params,
        // サーバ側 Lambda の上限(30秒)に合わせる。これより短いとクエリ完了前に
        // クライアントが諦めてしまうため、短くしない。
        timeout: 30000,
      });
      return response.data;
    } catch (error) {
      lastError = error;
      if (attempt < MAX_RETRIES && isRetriableError(error)) {
        // 失敗した試行がDBキャッシュを温めるため、リトライすると後続が高速化して
        // 成功しやすくなる（ハブアドレス対策）。指数バックオフで再試行する。
        const delay = RETRY_BASE_DELAY_MS * Math.pow(2, attempt);
        console.warn(
          `History API retry ${
            attempt + 1
          }/${MAX_RETRIES} after error; waiting ${delay}ms`,
          error
        );
        await sleep(delay);
        continue;
      }
      break;
    }
  }

  console.error("Error fetching data from API:", lastError);
  throw lastError;
}
